<template>
  <div>
    <v-flex v-if="language == 'de-CH'">
      <v-text-field
        label="Deutsch"
        :value="value"
        placeholder=" "
        :disabled="canUserEdit ? false : true"
        @input="updateValue($event)"
        @change="updateValidation"
      />
    </v-flex>
    <v-flex v-if="language == 'fr-CH'">
      <v-text-field
        label="Französisch"
        :value="value"
        placeholder=" "
        :disabled="canUserEdit ? false : true"
        @input="updateValue($event)"
        @change="updateValidation"
      />
    </v-flex>
    <v-flex v-if="language == 'it-CH'">
      <v-text-field
        label="Italienisch"
        :value="value"
        placeholder=" "
        :disabled="canUserEdit ? false : true"
        @input="updateValue($event)"
        @change="updateValidation"
      />
    </v-flex>
  </div>
</template>

<script>
export default {
  props: {
    canUserEdit: {
      type: Boolean,
      default: false,
    },
    value: {
      type: String,
      default: "",
    },
    language: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      translationValue: this.value,
    };
  },
  methods: {
    updateValue: function (value) {
      this.$emit("update:value", value);
    },
    updateValidation() {
      this.$emit("updateValidation");
    },
  },
};
</script>

<style>
.secoundPanel .v-expansion-panel__header {
  background-color: white !important;
  background: white !important;
  color: black !important;
  border-bottom: 1px solid #808080 !important;
}

.objectCard {
  border: 1px solid rgba(204, 204, 204, 0.5) !important;
  border-radius: 4px !important;
  background: rgba(204, 204, 204, 0.1) !important;
}
</style>
